import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { TutorialFile } from '@/modules/infodayco/shared/domain/tutorial-file';
import { TutorialsView } from '@/modules/infodayco/shared/domain/tutorials.view';
import { VideoTutorial } from '@/modules/infodayco/shared/domain/video-tutorial';
import { FileCreationRequest } from '@/modules/infodayco/shared/domain/file-creation.request';

class Tutorials extends HttpRepository {
    private static readonly RESOURCE = 'tutorials';
    private static readonly VIDEO_RESOURCE = 'video-tutorials';
    async getAll(): Promise<TutorialsView> {
        return (
            await this.get(this.createUri([Tutorials.RESOURCE]), this.createAuthorizationHeader())
        ).data;
    }

    getTutorial(tutorial: TutorialFile) {
        return this.get(
            this.createUri([`${Tutorials.RESOURCE}/${tutorial.id}`]),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    deleteTutorial(tutorial: TutorialFile) {
        return this.delete(
            this.createUri([`${Tutorials.RESOURCE}/${tutorial.id}`]),
            this.createAuthorizationHeader(),
        );
    }

    deleteVideoTutorial(videoTutorial: VideoTutorial) {
        return this.delete(
            this.createUri([`${Tutorials.VIDEO_RESOURCE}/${videoTutorial.id}`]),
            this.createAuthorizationHeader(),
        );
    }

    async uploadTutorial(request: FileCreationRequest): Promise<TutorialFile> {
        const formData = new FormData();
        formData.set('file', request.file, request.file.name);
        formData.append('name', request.name);
        return (
            await this.post(`${Tutorials.RESOURCE}`, formData, this.createAuthorizationHeader())
        ).data;
    }

    async uploadVideoTutorial(request: VideoTutorial): Promise<TutorialFile> {
        return (
            await this.post(
                `${Tutorials.VIDEO_RESOURCE}`,
                request,
                this.createAuthorizationHeader(),
            )
        ).data;
    }
}
const tutorialsRepository = new Tutorials();
export default tutorialsRepository;
